<template>
  <section class="header">
    <div
      v-if="back.length"
      class="header__arrow"
      @click="$router.push(back)"
    />
    {{ title }}
  </section>
</template>

<script>
export default {
  name: 'DriversHeader',
  props: {
    title: {
      type: String,
      default: '',
    },
    back: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="sass" scoped>
.header
  position: fixed
  top: 0
  left: 0
  right: 0
  display: flex
  justify-content: center
  align-items: center
  height: 5rem
  font-weight: 700
  font-size: 1.6rem
  line-height: 2rem
  background: #FFFFFF
  color: #5C5C5C
  box-shadow: 0 0 2rem rgba(132, 132, 132, 0.2)
  border-radius: 0 0 1.2rem 1.2rem
  z-index: 50

  &__arrow
    position: absolute
    top: 1.3rem
    left: 1rem
    width: 2.4rem
    height: 2.4rem
    background: url("~@/assets/img/new-angle-left.svg")
    background-size: cover
    cursor: pointer
</style>
